// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--wylie-purple) 0%, var(--wylie-pink) 100%);
}

.login-box {
  background-color: var(--wylie-white);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
}

.login-box h1 {
  text-align: center;
  color: var(--wylie-black);
  margin-bottom: 10px;
  font-size: 1.8rem;
}

.login-box h2 {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
  font-size: 1.2rem;
  font-weight: 400;
}

.login-box form {
  display: flex;
  flex-direction: column;
}

/* Outlined like App.css's buttons. */
.login-box button {
  margin-top: 10px;
  background-color: transparent;
  color: var(--part5-color);
  padding: 12px;
  border: 1px solid var(--part5-color);
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.login-box button:hover:not(:disabled) {
  background-color: var(--part5-color);
  color: var(--wylie-white);
}

.force-pw-account {
  color: var(--wylie-black);
  font-size: 0.95rem;
  line-height: 1.4;
  margin-bottom: 8px;
  text-align: center;
}

.force-pw-hint {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 20px;
  text-align: center;
}

.show-password-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  color: #666;
  font-size: 0.85rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.show-password-toggle input {
  width: auto;
  margin: 0;
  cursor: pointer;
}

.login-box button.force-pw-logout {
  margin-top: 16px;
  background: none;
  border: none;
  color: #666;
  font-size: 0.85rem;
  font-weight: 400;
  padding: 6px;
  width: 100%;
}

.login-box button.force-pw-logout:hover:not(:disabled) {
  background: none;
  color: var(--wylie-purple);
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mFAAmF;AACrF;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--wylie-purple) 0%, var(--wylie-pink) 100%);\n}\n\n.login-box {\n  background-color: var(--wylie-white);\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-box h1 {\n  text-align: center;\n  color: var(--wylie-black);\n  margin-bottom: 10px;\n  font-size: 1.8rem;\n}\n\n.login-box h2 {\n  text-align: center;\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n.login-box form {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Outlined like App.css's buttons. */\n.login-box button {\n  margin-top: 10px;\n  background-color: transparent;\n  color: var(--part5-color);\n  padding: 12px;\n  border: 1px solid var(--part5-color);\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.login-box button:hover:not(:disabled) {\n  background-color: var(--part5-color);\n  color: var(--wylie-white);\n}\n\n.force-pw-account {\n  color: var(--wylie-black);\n  font-size: 0.95rem;\n  line-height: 1.4;\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.force-pw-hint {\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.show-password-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  color: #666;\n  font-size: 0.85rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.show-password-toggle input {\n  width: auto;\n  margin: 0;\n  cursor: pointer;\n}\n\n.login-box button.force-pw-logout {\n  margin-top: 16px;\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 0.85rem;\n  font-weight: 400;\n  padding: 6px;\n  width: 100%;\n}\n\n.login-box button.force-pw-logout:hover:not(:disabled) {\n  background: none;\n  color: var(--wylie-purple);\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
